/**
 * Get a comparator function for sorting leads by a specific key
 */
export function getLeadComparator(key) {
    return (a, b) => {
        const getName = (l) => l.FullName || [l.FirstName, l.LastName].filter(Boolean).join(' ') || l.Email || '';
        switch (key) {
            case 'lead':
                return getName(a).localeCompare(getName(b));
            case 'phone':
                return (a.Phone || a.GlobalContactPhone || '').localeCompare(b.Phone || b.GlobalContactPhone || '');
            case 'enrichment':
                return (a.EnrichmentStatus || '').localeCompare(b.EnrichmentStatus || '');
            case 'company':
                return (a.Company || '').localeCompare(b.Company || '');
            case 'title':
                return (a.JobTitle || '').localeCompare(b.JobTitle || '');
            case 'attributionSource':
                return (a.WebSourceAttributions?.[0]?.Source || '').localeCompare(b.WebSourceAttributions?.[0]?.Source || '');
            case 'webinarAttended':
                return (a.WebinarAttended === b.WebinarAttended) ? 0 : (a.WebinarAttended ? -1 : 1);
            case 'lastConversion':
                return (a.LastInteractionAt || '').localeCompare(b.LastInteractionAt || '');
            case 'conversions':
                return a.InteractionCount - b.InteractionCount;
            case 'signal':
                return a.SignalScore - b.SignalScore;
            default:
                return 0;
        }
    };
}
/**
 * Get a comparator function for sorting companies by a specific key
 */
export function getCompanyComparator(key) {
    return (a, b) => {
        switch (key) {
            case 'company':
                return (a.CompanyName || '').localeCompare(b.CompanyName || '');
            case 'industry':
                return (a.Industry || '').localeCompare(b.Industry || '');
            case 'size':
                return (a.StaffCountRange || '').localeCompare(b.StaffCountRange || '');
            case 'lastConversion':
                return (a.LastConversionAt || '').localeCompare(b.LastConversionAt || '');
            case 'leads':
                return a.LeadCount - b.LeadCount;
            case 'signal':
                return a.SignalScore - b.SignalScore;
            default:
                return 0;
        }
    };
}
